
import { defineComponent } from "vue";

export default defineComponent({
    name: "FormErrors",
    props: {
       errors: {
           type: Array,
           required: true,
       }
    }
});
